import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import type { CompactMenuItem } from "../types";
import { DEFAULT_ACTIVE_ITEM_CLASSES, DEFAULT_FOCUS_ITEM_CLASSES, DEFAULT_INACTIVE_ITEM_CLASSES, DEFAULT_ITEM_CLASSES } from "../constants";
interface CompactMenuItemButtonProps {
  readonly item: CompactMenuItem;
  readonly isActive: boolean;
  readonly menuActive: boolean;
  readonly onClick: () => void;
  readonly itemClassName?: string | undefined;
  readonly activeItemClassName?: string | undefined;
  readonly inactiveItemClassName?: string | undefined;
  readonly focusItemClassName?: string | undefined;
  readonly unstyledItems?: boolean | undefined;
}
export function CompactMenuItemButton(t0) {
  const $ = _c(43);
  const {
    item,
    isActive,
    menuActive,
    onClick,
    itemClassName,
    activeItemClassName,
    inactiveItemClassName,
    focusItemClassName,
    unstyledItems: t1
  } = t0;
  const unstyledItems = t1 === undefined ? false : t1;
  const activeDefaultClasses = unstyledItems ? undefined : DEFAULT_ACTIVE_ITEM_CLASSES;
  const inactiveDefaultClasses = unstyledItems ? undefined : DEFAULT_INACTIVE_ITEM_CLASSES;
  const focusDefaultClasses = unstyledItems ? undefined : DEFAULT_FOCUS_ITEM_CLASSES;
  let t10;
  let t11;
  let t12;
  let t13;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== activeDefaultClasses || $[1] !== activeItemClassName || $[2] !== focusDefaultClasses || $[3] !== focusItemClassName || $[4] !== inactiveDefaultClasses || $[5] !== inactiveItemClassName || $[6] !== isActive || $[7] !== item || $[8] !== itemClassName || $[9] !== menuActive || $[10] !== onClick || $[11] !== unstyledItems) {
    const stateClasses = isActive ? clsx(activeDefaultClasses, activeItemClassName) : clsx(inactiveDefaultClasses, inactiveItemClassName);
    const focusClasses = menuActive && !item.disabled && !isActive ? clsx(focusDefaultClasses, focusItemClassName) : undefined;
    const role = item.role ?? "menuitem";
    t2 = "button";
    t3 = role;
    t4 = item.ariaSelected;
    t5 = item.ariaLabel;
    t6 = item.disabled;
    t7 = "true";
    t8 = item.id;
    t9 = isActive ? "true" : "false";
    t10 = item.disabled ? "true" : "false";
    t11 = item["data-testid"];
    t12 = onClick;
    t13 = clsx(unstyledItems ? undefined : DEFAULT_ITEM_CLASSES, stateClasses, focusClasses, itemClassName, item.className, item.disabled && !unstyledItems && "tw-cursor-not-allowed tw-opacity-60 tw-text-iron-500");
    $[0] = activeDefaultClasses;
    $[1] = activeItemClassName;
    $[2] = focusDefaultClasses;
    $[3] = focusItemClassName;
    $[4] = inactiveDefaultClasses;
    $[5] = inactiveItemClassName;
    $[6] = isActive;
    $[7] = item;
    $[8] = itemClassName;
    $[9] = menuActive;
    $[10] = onClick;
    $[11] = unstyledItems;
    $[12] = t10;
    $[13] = t11;
    $[14] = t12;
    $[15] = t13;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t10 = $[12];
    t11 = $[13];
    t12 = $[14];
    t13 = $[15];
    t2 = $[16];
    t3 = $[17];
    t4 = $[18];
    t5 = $[19];
    t6 = $[20];
    t7 = $[21];
    t8 = $[22];
    t9 = $[23];
  }
  let t14;
  if ($[24] !== item.icon) {
    t14 = item.icon && <span className="tw-flex tw-shrink-0 tw-items-center tw-justify-center">{item.icon}</span>;
    $[24] = item.icon;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== item.label) {
    t15 = <span className="tw-flex-1 tw-text-left">{item.label}</span>;
    $[26] = item.label;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t10 || $[29] !== t11 || $[30] !== t12 || $[31] !== t13 || $[32] !== t14 || $[33] !== t15 || $[34] !== t2 || $[35] !== t3 || $[36] !== t4 || $[37] !== t5 || $[38] !== t6 || $[39] !== t7 || $[40] !== t8 || $[41] !== t9) {
    t16 = <button type={t2} role={t3} aria-selected={t4} aria-label={t5} disabled={t6} data-compact-menu-item={t7} data-menu-item-id={t8} data-active={t9} data-disabled={t10} data-testid={t11} onClick={t12} className={t13}>{t14}{t15}</button>;
    $[28] = t10;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
    $[34] = t2;
    $[35] = t3;
    $[36] = t4;
    $[37] = t5;
    $[38] = t6;
    $[39] = t7;
    $[40] = t8;
    $[41] = t9;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  return t16;
}